/* eslint-disable import/prefer-default-export */
import PropTypes from 'prop-types';

export const productPropType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  shopifyIds: PropTypes.string.isRequired,
  sku: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  subTitle: PropTypes.string.isRequired,
  referral: PropTypes.shape({
    discount: PropTypes.number.isRequired,
    payment: PropTypes.number.isRequired,
  }),
  price: PropTypes.number.isRequired,
  msrp: PropTypes.number.isRequired,
  formattedDeliveryDate: PropTypes.string.isRequired,
  delivery: PropTypes.string.isRequired,
  backordered: PropTypes.bool.isRequired,
  referralDiscount: PropTypes.string,
});
